<template>
  <div class="warp">
    <headers @custom-event="receiveFromChild"></headers>
    <pos_top1  :posData="systemTitle"></pos_top1>
    <div class="content">
      <div class="menuBox">
        <menuData class="menuData1" @custom-event="receiveFromChild"></menuData>
      </div>

      <div class="content_box">
        <div class="component_box">
          <div class="header">{{childMessage}}</div>
          <div class="component_box_">
            <router-view></router-view>
          </div>



        </div>
      </div>

    </div>
    <footers></footers>
  </div>
</template>

<script>
import headers from '@comm/components/headers.vue'
import footers from '@comm/components/footers.vue'
import pos_top1 from "../../../comm/components/pos_title_top.vue";
import menuData from "../../components/menuData.vue";

export default {
  components: {
    headers, footers,pos_top1,menuData
  },
  name: "index",
  watch:{
    $router(to,from){
      // console.log(to,'0000----0000')
      // console.log(from,'111----0000')
    },

     $route(to,from){
      // console.log(to.meta.title,'0000----0000')
      // console.log(from,'111----0000')
    }
  },
  data(){
    return{
      systemTitle: '地理标志产品保护申请电子受理系统',
      childMessage:'',
    }
  },
  mounted() {
    this.childMessage = localStorage.getItem('titles') || '首页';
  },
  methods:{
    receiveFromChild(payload) {
      this.childMessage = payload ;
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/landmark-user/views/home_menu/index.vue